module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAMAAACOacfrAAAAOVBMVEUAAAD///////////////////////////////////////////////////////////////////////8KOjVvAAAAEnRSTlMAKPjz7MS8tqybiHdkUkM1DAfQ4tNoAAAAQUlEQVQI12WOSQoAIRAD29kX1/z/sUJ5EDWHgoKmE3OnM0BuHQlg+dIeAVoebQEYeSXfQD7pB4v1y/lLb1jax2UVcSMEYTbF7BcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_expend_hover.png
// module id = TLpI
// module chunks = 9